export enum EmailEditorModes {
  VISUAL = 'visual',
  HTML = 'html',
}
